import { Typography } from '@mui/material';

import { colors } from 'src/global/styles/colors';
import { useTheme } from 'src/provider/ThemeCustomizationProvider';

import { StepAccordion } from '../StepAccordion';
import { ThemeEditor } from './ThemeEditor/ThemeEditor';
import { ThemePreview } from './ThemePreview/ThemePreview';

export function ThemeCustomization() {
  const { themeError } = useTheme();

  return (
    <StepAccordion
      isError={themeError.favicon.isError || themeError.featureImage.isError || themeError.logo.isError}
      index={8}
      title='Theme Customization'
      open={false}>
      <ThemePreview />
      <ThemeEditor />

      {themeError.favicon.isError || themeError.featureImage.isError || themeError.logo.isError ? (
        <Typography paddingTop={1} color={colors.error} fontSize={'14px'}>
          Please upload images
        </Typography>
      ) : null}
    </StepAccordion>
  );
}
